import { render, staticRenderFns } from "./InventoryStockOpnameReport.vue?vue&type=template&id=273fb0cc"
import script from "./InventoryStockOpnameReport.vue?vue&type=script&lang=js"
export * from "./InventoryStockOpnameReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports